import React from "react";
import { Icon } from "@amzn/awsui-components-react-v3";
import Link from "@amzn/awsui-components-react-v3/polaris/link";
import CopyToClipboard from "@amzn/awsui-components-react-v3/polaris/copy-to-clipboard";

const COPYABLE_FIELDS = new Set([
    "awsAccountId",
    "awsAccountName",
    "awsAccountOwnerTeamId",
    "awsAccountOwnerTeamName",
    "linkedCradleAccounts",
    "userAlias",
    "teamSharedS3BucketName",
    "teamSharedS3BucketCradleWriteRole",
    "personalS3BucketName",
    "personalS3BucketCradleWriteRole",
    "personalConsoleAccessRole",
]);

export const INFO_TABLE_COLUMN_DEFINITIONS = [
    {
        id: "name",
        header: "Property Name",
        cell: (item: any) => item.key,
        width: 360
    },
    {
        id: "value",
        header: "Property Value",
        cell: (item: any) => {
            // Check if this is the userStatus field and customize based on value
            if (item.key === "userStatus") {
                const status = item.value?.toLowerCase();
                if (status === "active") {
                    return (
                        <span>
                            Active. Ready to go! <Icon name="status-positive" />
                        </span>
                    );
                } else if (status === "unknown") {
                    return (
                        <span>
                            Unknown. This usually means you need to activate (see button below) <Icon name="status-pending" />
                        </span>
                    );
                } else if (status === "activating") {
                    return (
                        <span>
                            Activating. This usually takes 30 minutes, enough for a coffee <Icon name="status-pending" />
                        </span>
                    );
                }
            }

            // Add link for awsAccountId
            if (item.key === "awsAccountId") {
                return (
                    <span>
                        {item.value}{" "}
                        <CopyToClipboard variant="icon" textToCopy={item.value} copyButtonAriaLabel="Copy account ID" copySuccessText="Account ID copied" copyErrorText="Failed to copy" />{" "}
                        [<Link external href={`https://conduit.security.a2z.com/accounts/aws/${item.value}/attributes`}>View in Conduit</Link>]
                    </span>
                );
            }

            // Add link for awsAccountOwnerTeamId
            if (item.key === "awsAccountOwnerTeamId") {
                return (
                    <span>
                        {item.value}{" "}
                        <CopyToClipboard variant="icon" textToCopy={item.value} copyButtonAriaLabel="Copy team ID" copySuccessText="Team ID copied" copyErrorText="Failed to copy" />{" "}
                        [<Link external href={`https://permissions.amazon.com/a/team/${item.value}`}>View in Team</Link>]
                    </span>
                );
            }

            // Add link for userAlias
            if (item.key === "userAlias") {
                return (
                    <span>
                        {item.value}{" "}
                        <CopyToClipboard variant="icon" textToCopy={item.value} copyButtonAriaLabel="Copy alias" copySuccessText="Alias copied" copyErrorText="Failed to copy" />{" "}
                        [<Link external href={`https://phonetool.amazon.com/users/${item.value}`}>View in Phonetool</Link>]
                    </span>
                );
            }

            // Copyable fields without special links (handle absent values)
            if (COPYABLE_FIELDS.has(item.key) && item.value) {
                return (
                    <span>
                        {item.value}{" "}
                        <CopyToClipboard variant="icon" textToCopy={item.value} copyButtonAriaLabel={`Copy ${item.key}`} copySuccessText="Copied" copyErrorText="Failed to copy" />
                    </span>
                );
            }

            return item.value || "-";
        },
    }
];
